import { closeSettings, navigateToSettings } from './navigationRef';

/**
 * Compatibility helpers. Settings is a stack screen; these open/close that page.
 */
export function openSettingsOverlay(): boolean {
  navigateToSettings();
  return true;
}

export function closeSettingsOverlay(): boolean {
  closeSettings();
  return true;
}
